import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnnouncementsListController } from 'fragments/announcements/interfaces';
import { useAPIAnnouncements } from 'services/announcements/api-announcements.service';
import { Announcement } from 'services/announcements/announcements.service';

export const useAnnouncementsListController = (): AnnouncementsListController => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { getSiteAnnouncements } = useAPIAnnouncements();

    const accessToken = searchParams.get('access_token') || '';
    const siteId = searchParams.get('site_id') || '';
    const isAdmin = searchParams.get('is_admin') === 'true';

    const [announcements, setAnnouncements] = useState<Announcement[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (accessToken && siteId) {
            getSiteAnnouncements(accessToken, siteId)
                .then(setAnnouncements)
                .catch(() => {
                    // el errorHandler centralizado (dentro del service) ya navega en errores de red/sesión
                })
                .finally(() => setLoading(false));
        } else {
            navigate('/mobile/404');
        }
    }, [accessToken, siteId]);

    const qs = `access_token=${accessToken}&site_id=${siteId}&is_admin=${isAdmin}`;

    const onOpen = (id: string) => navigate(`/mobile/announcements/${id}?${qs}`);
    const onCompose = () => navigate(`/mobile/announcements/compose?${qs}`);

    return {
        state: { announcements, loading, isAdmin },
        events: { onOpen, onCompose },
    };
};
